<template>
	<div class="participants" id="participant_list" :style="container_style">
		<div class="user_dash_panel participant" v-for="participant in participants" v-if="participant != 'empty'" :style="'--accent:' + accent">
			<div class="participant_head">
				<h3 v-if="participant.name != ''">
					{{ participant.name }}
					<template v-if="participant.is_organiser">(Organiser)</template>
				</h3>
				<button type="button" class="button small accent solid" v-else v-on:click="toggleParticipantForm(participant)">Add Details</button>
				<p class="red" v-if="participant.outstanding > 0">
					<b>{{ participant.formatted_outstanding }}</b> outstanding
					<span><i class="fas fa-fw fa-times"></i></span>
				</p>
				<p class="green" v-else>
					Paid in full
					<span><i class="fas fa-fw fa-check"></i></span>
				</p>
				<button type="button" class="chevron">
					<i class="fas fa-fw fa-chevron-down"></i>
				</button>
			</div>
			<div class="participant_body">
				<div>
					<p v-if="participant.telephone"><b>Telephone:</b> {{ participant.telephone }}</p>
					<p v-if="participant.email_address"><b>Email:</b> {{ participant.email_address }}</p>
					<ul v-if="participant.payments.length > 0">
						<li v-for="payment in participant.payments">
							<span><b>Date:</b> {{ payment.date }}</span>
							<template v-if="payment.paid_by == 'Hangover Weekends'">
								<span>Added manually by Hangover Weekends</span>
							</template>
							<template v-else>
								<span><b>Paid By:</b> {{ payment.paid_by }}</span>
							</template>
							<span><b>Amount:</b> {{ payment.formatted_amount }}</span>
						</li>
					</ul>
					<p>
						<template v-if="participant.has_user == true">
							<small v-if="participant.is_organiser">Organiser details can not be edited.</small>
							<small v-else>Participant can not be edited as a user account is connected, please call us for help.</small>
						</template>
						<button type="button" class="button small mono" v-if="participant.has_user == false && participant.name!=''" v-on:click="toggleParticipantForm(participant)">
							<span class="fa-stack fa-1x">
								<i class="fas fa-user-edit fa-stack-2x"></i>
							</span>
							Edit
						</button>
						<button type="button" class="button small mono thin" v-if="1==2 && participant.has_user == false" v-on:click="removeParticipant(participant)">
							<i class="fas fa-trash" ></i>
							Remove
						</button>
						<payment-button v-if="participant.outstanding > 0" type="payment" look="participant" :uuid="uuid" :participant_id="participant.id" :accent="accent">
							<button type="button" class="button small accent solid" style="margin-left: auto;">
								<span class="fa-stack fa-1x">
									<i class="fal fa-circle fa-stack-2x"></i>
									<i class="fas fa-pound-sign fa-stack-1x"></i>
								</span>
								Make a payment
							</button>
						</payment-button>
					</p>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
export default {

	props: [
		'uuid',
		'accent',
		'container_style'
	],

	data: () => {
		return {
			participants: {}
		}
	},

	computed: {
	},

	watch: {
	},

	created() {
	},

	mounted() {
		this.getParticipants();
	},

	methods: {

		...mapActions(['addAlert']),
		
		getParticipants: function(){
			axios.post('/ajax/getParticipants', {
				uuid: this.uuid
			})
			.then(response => {
				this.participants = response.data
			})
			.catch(error => {
				console.log(error);
			});
		},

		removeParticipant: function(participant) {
			axios.post('/ajax/removeParticipant', {
				uuid: this.uuid,
				participant_id: participant.id
			})
			.then(response => {
				if(response.data=='success') {
					this.getParticipants();
					var self = this;
					setTimeout(function() {
						self.alert('<strong>Great!</strong> The participant list has been updated', 'success')
					}, 500);
					
				}else{
					this.errors = response.data['errors'];
					document.getElementById('participant_list').scrollIntoView({behavior: "smooth"});
				}
			})
			.catch(error => {
				if(error.response.status == 422) {
					var errors = error.response.data['errors'];
					this.errors = errors;
					document.getElementById('participant_list').scrollIntoView({behavior: "smooth"});
				}
			});
		},

		toggleParticipantForm: function(participant = null){
			this.$root.$refs.participantform.toggleParticipantForm(participant);
		},

		alert: function(message, type, important = false) {
			this.addAlert({
				alertClass: 'alert-' + type, 
				alertMessage: message, 
				alertImportant: important,
			});
		},
	}
};
</script>